import { MatDialog } from "@angular/material/dialog";
import { mode } from "../../../mode/mode";
import { FileManagerService } from "./file-manager.service";
import { VISOL_FILE_PICKER_SERVICE } from "./visol-file-picker.service";
import { BrowserVisolFilePickerService } from "./browser-visol-file-picker.service";
import { ElectronFilePickerService } from "./electron-file-picker.service";

export function provideVisolFilePicker() {
  const isBrian = () => mode.name === "brian";
  return {
    provide: VISOL_FILE_PICKER_SERVICE,
    useFactory: (dialog: MatDialog, fileManagerService: FileManagerService) => {
      return isBrian() ? new ElectronFilePickerService(dialog, fileManagerService) : new BrowserVisolFilePickerService();
    },
    deps: [MatDialog, FileManagerService]
  };
}
